import Cookies from "js-cookie";
const removeAllCookies = () => {
  Object.keys(Cookies.get()).forEach((key) => {
    Cookies.remove(key, { path: "/" });
  });
};

function obtenerValorDeLaCookie(nombreCookie) {
  const nombre = `${nombreCookie}=`;
  const cookies = document.cookie.split(";");

  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i].trim();
    if (cookie.startsWith(nombre)) {
      return cookie.substring(nombre.length, cookie.length);
    }
  }
  return null;
}

const extractPatientIdFromUrl = () => {
  const url = window.location.href;
  const parts = url.split("/");
  const patientIdIndex = parts.indexOf("profile") + 1;
  const patientId = parts[patientIdIndex];
  return patientId;
};

const esCorreoValido = (email) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
};

function getInitials(name) {
  return name.match(/(\b\S)?/g).join("");
}

export {
  removeAllCookies,
  obtenerValorDeLaCookie,
  extractPatientIdFromUrl,
  esCorreoValido,
  getInitials,
};
